import type { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseAsString, useQueryStates } from 'nuqs';
import DashboardContext from '../../helpers/contexts/dashboardContext';
import { buildFilterQueryParams, filterLocationsBySelectedDateRange } from '../../helpers/utils';
import { setDateRangeWithLocations, setLocationFilter } from '../../state/features/filters/actions';
import type { RootState } from '../../state/store';
import { format } from 'date-fns';

const PrimaryFilterHelper = ({ children }: { children: ReactNode }) => {
  const [, setDateQuery] = useQueryStates(
    {
      from: parseAsString,
      to: parseAsString
    },
    { history: 'replace' }
  );
  const dispatch = useDispatch();
  const companyLocations = useSelector((state: RootState) => state.locations);

  const applyFilter = ({ type, data }: { type: string; data: any }) => {
    switch (type) {
      case 'date': {
        const { dateRange, timeRange } = data;
        const queryParams = buildFilterQueryParams({ dateRange, timeRange });
        setDateQuery(queryParams);
        const updatedLocations = companyLocations.filter((d) =>
          data?.selectedLocations.includes(d.id)
        );
        const filteredLocations = filterLocationsBySelectedDateRange(updatedLocations, dateRange);
        const locationIds = filteredLocations.map((d) => d.id);

        if (locationIds.length === 0) {
          console.error('No locations available within the selected date range');
          const defaultDateRange = [
            format(new Date(), 'yyyy-MM-dd'),
            format(new Date(), 'yyyy-MM-dd')
          ];
          dispatch(
            setDateRangeWithLocations({
              locationIds: [],
              selectedDateRange: defaultDateRange,
              selectedTimeRange: timeRange
            })
          );
          return;
        }
        dispatch(
          setDateRangeWithLocations({
            locationIds,
            selectedDateRange: dateRange,
            selectedTimeRange: timeRange
          })
        );
        break;
      }
      case 'location': {
        const filteredLocations = filterLocationsBySelectedDateRange(
          data?.selectedLocations,
          data?.dateRange
        );
        dispatch(setLocationFilter(filteredLocations.map((loc) => loc.id)));
        break;
      }
      default:
        break;
    }
  };

  return <DashboardContext.Provider value={{ applyFilter }}>{children}</DashboardContext.Provider>;
};

export default PrimaryFilterHelper;
